import React from "react";

const PeopleIcon = () => {
  return (
    <svg width="52" height="52" viewBox="0 0 52 52" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g clipPath="url(#clip0_7218_43632)">
        <circle cx="26.0001" cy="26" r="20.4286" fill="#D8D8D8" />
        <path
          d="M26 0C11.7 0 0 11.7 0 26C0 40.3 11.7 52 26 52C40.3 52 52 40.3 52 26C52 11.7 40.3 0 26 0ZM26 10.1111C29.1778 10.1111 31.7778 12.7111 31.7778 15.8889C31.7778 19.0667 29.1778 21.6667 26 21.6667C22.8222 21.6667 20.2222 19.0667 20.2222 15.8889C20.2222 12.7111 22.8222 10.1111 26 10.1111ZM11.5556 40.4444C11.5556 32.5 18.0556 26 26 26C33.9444 26 40.4444 32.5 40.4444 40.4444H11.5556Z"
          fill="#F5F5F5"
        />
      </g>
      <defs>
        <clipPath id="clip0_7218_43632">
          <rect width="52" height="52" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};

export default PeopleIcon;
